import React, {useState} from 'react';
import {FormSubmissionError, RequiredFieldMessage} from "../components/FormElements";
import {Formik} from "formik";
import * as yup from "yup";
import {
    EmailValidation,
    FirstNameValidation,
    LastNameValidation,
    RecaptchaValidation
} from "../components/FormValidations";
import {SuccessMessage} from "../components/Messages";
import InputField from "../components/InputField";
import TextareaField from "../components/TextareaField";
import handleFormSubmit, {contactUsEndpoint} from "../client-api/ANZAPI";
import NumberField from "../components/NumberField";
import {updateLinkTrackingFields} from "../components/LinkTracking";
import RecapthaField from "../components/RecapthaField";

const FIRST_NAME_FIELD = 'FirstName';
const LAST_NAME_FIELD = 'LastName';
const EMAIL_FIELD = 'Email';
const MOBILE_FIELD = 'Mobile';
const MESSAGE_FIELD = 'Message';
const RECAPTCHA_FIELD = 'Recaptcha';

const initialValues = {
    [FIRST_NAME_FIELD]: '',
    [LAST_NAME_FIELD]: '',
    [EMAIL_FIELD]: '',
    [MOBILE_FIELD]: '',
    [MESSAGE_FIELD]: '',
    [RECAPTCHA_FIELD]: ''
}

const submissionValidation = yup.object().shape({
    [FIRST_NAME_FIELD]: FirstNameValidation,
    [LAST_NAME_FIELD]: LastNameValidation,
    [EMAIL_FIELD]: EmailValidation,
    [MESSAGE_FIELD]: yup.string().required('Message is required').max(1000),
    [RECAPTCHA_FIELD]: RecaptchaValidation
})

const confirmationLinkTrackingStage = {
    pageName: "anzcourtside:contact-us:confirmation",
    formName: "anzcourtside:contact-us",
    formStatus: "submitted",
    journeyName: "contact_us:anzcourtside",
    journeyStepName: "contact_us:confirmation",
    journeyStatus: "complete"
}

const ContactForm = (props) => {
    const [successSubmitting, setSuccessSubmitted] = useState(false);
    const [submissionError, setSubmissionError] = useState(null)

    return (
        <>
            {successSubmitting === true ? (
                <SuccessMessage
                    heading={'Thanks for contacting ANZ Courtside.'}
                    message={'We will be in touch as soon as possible.'}
                />
            ) : (
                <>
                    <RequiredFieldMessage/>
                    <hr/>
                    <Formik
                        initialValues={{...initialValues}}
                        initialErrors={{...initialValues}}
                        onSubmit={(values, {setSubmitting, resetForm}) => {
                            handleFormSubmit(values, contactUsEndpoint(props.elementId))
                                .then((res) => {
                                    setSubmitting(false)
                                    if (res.success) {
                                        resetForm({...initialValues});
                                        setSuccessSubmitted(true);
                                        [].forEach.call(
                                            document.querySelectorAll('.contact-title'),
                                            (target) => {
                                                target.style.display = 'none';
                                            }
                                        );

                                        updateLinkTrackingFields(confirmationLinkTrackingStage)
                                        pageView();

                                        return;
                                    }

                                    setSubmissionError(res?.message)
                                    $('html, body').animate({
                                        'scrollTop': document.getElementById("submissionErrorId").offsetTop - 50
                                    }, 500);
                                })
                        }}
                        validationSchema={submissionValidation}
                    >{(formikProps) => (
                        <>
                            {submissionError !== null && (
                                <div id={'submissionErrorId'}>
                                    <FormSubmissionError message={submissionError}/>
                                </div>
                            )}

                            <form onSubmit={formikProps.handleSubmit}>
                                <InputField
                                    id={'firstName'}
                                    label={'First name'}
                                    name={FIRST_NAME_FIELD}
                                    required={true}
                                    maxLength={30}
                                    {...formikProps}
                                />

                                <InputField
                                    id={'lastName'}
                                    label={'Last name'}
                                    name={LAST_NAME_FIELD}
                                    required={true}
                                    maxLength={30}
                                    {...formikProps}
                                />

                                <NumberField
                                    label={'Mobile'}
                                    className={'short'}
                                    name={MOBILE_FIELD}
                                    id={'mobile'}
                                    allowNegative={false}
                                    maxLength={20}
                                />

                                <InputField
                                    id={'email'}
                                    label={'Email'}
                                    name={EMAIL_FIELD}
                                    required={true}
                                    maxLength={129}
                                    type={'email'}
                                    {...formikProps}
                                />

                                <div className={'row'}>
                                    <div className={'col-12'}>
                                        <TextareaField
                                            label={'Message'}
                                            name={MESSAGE_FIELD}
                                            id={'email'}
                                            required={true}
                                            fieldLength={'full'}
                                            maxLength={1000}
                                            {...formikProps}
                                        />
                                    </div>

                                    <div className={'col-12'}>
                                        <div className={'form-group mb-0'}>
                                            <RecapthaField name={RECAPTCHA_FIELD} />
                                        </div>
                                    </div>
                                </div>

                                <hr/>

                                <button
                                    type="submit"
                                    className={'btn btn-primary'}
                                    disabled={Object.keys(formikProps.errors).length > 0 || formikProps.isSubmitting}
                                >Submit</button>
                            </form>
                        </>
                    )}
                    </Formik>
                </>
            )}
        </>
    )
}

export default ContactForm;
